import Outdoor1 from './../images/works/Outdoor/Ecstasy_1_Billboard.jpg'
import Outdoor2 from './../images/works/Outdoor/Jatra_1_Billboard.jpg'

const Outdoor = [Outdoor1, Outdoor2]

export default Outdoor;